import axios from 'axios';

let prefix = "/creep-preset-group"

const CreepPresetGroupApi = {
	listCreepPresetGroup(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	// getCreepPresetGroup(payload) {
	// 	return axios.get(prefix + "/get", { params: payload })
	// },
	archiveCreepPresetGroup(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	},
	createCreepPresetGroup(payload) {
		return axios.post(prefix + "/create", payload)
	},
}

export default CreepPresetGroupApi;